/* eslint-disable no-undef */
import {getTranslation} from './translations';

const computed = typeof Vue !== 'undefined' ? Vue.computed : null;


const template = `
    <nav class="ubf-dynamicList__pagination" aria-label="Pagination">
    	<template v-if="totalPages > 1">
    		<button class="ubf-dynamicList__pageArrow ubf-dynamicList__pageArrow--first" type="button" @click="goFirst" :disabled="page <= 1" :aria-label="trans('First')">
				<span data-type="svg" aria-hidden="true"><canvas width="20" height="20"></canvas><svg viewBox="0 0 20 20" focusable="false" aria-hidden="true"><use xlink:href="#pagination-last"></use></svg></span>
			</button>
			<button class="ubf-dynamicList__pageArrow ubf-dynamicList__pageArrow--prev" type="button" @click="goPrev" :disabled="page <= 1" :aria-label="trans('Previous')">
				<span data-type="svg" aria-hidden="true"><canvas width="20" height="20"></canvas><svg viewBox="0 0 20 20" focusable="false" aria-hidden="true"><use xlink:href="#pagination-next"></use></svg></span>
			</button>
			<template v-for="(p, index) in pages" :key="index">
				<span v-if="p === '...'" class="ubf-dynamicList__page ubf-dynamicList__page--ellipsis" aria-hidden="true"><span>...</span></span>
				<button v-else :class="{ 'ubf-dynamicList__page--current': p === page }" class="ubf-dynamicList__page"
					type="button"
					@click="goTo(p)"
					:aria-current="p === page ? 'page' : null"
					:aria-label="trans('Page') + ' ' + p"
				>{{ p }}</button>
			</template>
			<button class="ubf-dynamicList__pageArrow ubf-dynamicList__pageArrow--next" type="button" @click="goNext" :disabled="page >= totalPages" :aria-label="trans('Next')">
				<span data-type="svg" aria-hidden="true"><canvas width="20" height="20"></canvas><svg viewBox="0 0 20 20" focusable="false" aria-hidden="true"><use xlink:href="#pagination-next"></use></svg></span>
			</button>
			<button class="ubf-dynamicList__pageArrow ubf-dynamicList__pageArrow--last" type="button" @click="goLast" :disabled="page >= totalPages" :aria-label="trans('Last')">
				<span data-type="svg" aria-hidden="true"><canvas width="20" height="20"></canvas><svg viewBox="0 0 20 20" focusable="false" aria-hidden="true"><use xlink:href="#pagination-last"></use></svg></span>
			</button>
		</template>
    </nav>
`;

export default {
	emits: ['update:page'],
	template: template,
	props: {
		total: {type: Number, required: true},
		page: {type: Number, default: 1},
		pageSize: {type: Number, default: 10},
		maxButtons: {type: Number, default: 5},
	},
	setup: function (props, ctx) {
		const totalPages = computed(() => {
			const ps = Math.max(1, Number(props.pageSize || 10));
			const t = Math.max(0, Number(props.total || 0));
			return t > 0 ? Math.max(1, Math.ceil(t / ps)) : 1;
		});

		const pages = computed(() => {
			const tp = totalPages.value;
			const cur = Math.min(Math.max(1, props.page || 1), tp);
			const maxVisible = props.maxButtons;

			if (tp <= maxVisible + 2) {
				// Show all pages if total is small
				return Array.from({length: tp}, (_, i) => i + 1);
			}

			const result = [];
			const halfVisible = Math.floor(maxVisible / 2);
			let start = Math.max(1, cur - halfVisible);
			const end = Math.min(tp, start + maxVisible - 1);

			// limit the range to be displayed, use ellipsis if necessary
			if (end === tp) {
				start = Math.max(1, end - maxVisible + 1);
			}
			if (start > 1) {
				result.push('...');
			}
			for (let i = start; i <= end; i++) {
				result.push(i);
			}
			if (end < tp) {
				result.push('...');
			}

			return result;
		});

		const goTo = (p) => {
			const tp = totalPages.value;
			const next = Math.min(Math.max(1, p), tp);
			if (next !== props.page) ctx.emit('update:page', next);
			const dlel = document.getElementById('dynamicList');
			if (dlel) {
				const top = dlel.getBoundingClientRect().top + window.pageYOffset;
				// wait for page update before scrolling
				requestAnimationFrame(() => {
					window.scrollTo({top: top - 120, behavior: 'smooth'});
				});
			}

		};
		const goPrev = () => goTo((props.page || 1) - 1);
		const goFirst = () => goTo(1);
		const goNext = () => goTo((props.page || 1) + 1);
		const goLast = () => goTo(totalPages.value);

		return {
			trans: getTranslation,
			totalPages: totalPages,
			pages: pages,
			goTo: goTo,
			goPrev: goPrev,
			goNext: goNext,
			goFirst: goFirst,
			goLast: goLast,
		};
	},
};
